import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import SmartStadium from "./pages/SmartStadium";
import SmartTemple from "./pages/SmartTemple";
import SmartEnergy from "./pages/SmartEnergy";
import SmartBuilding from "./pages/SmartBuilding";

function App() {
  useEffect(() => {
    // Google Analytics will be initialized here
    if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_GA_MEASUREMENT_ID) {
      // GA4 initialization placeholder
      console.log('GA4 ready for production');
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/smart-stadium" element={<SmartStadium />} />
          <Route path="/smart-temple" element={<SmartTemple />} />
          <Route path="/smart-energy" element={<SmartEnergy />} />
          <Route path="/smart-building" element={<SmartBuilding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
